import React from 'react';

type Context = {
  appName: string;
  useMessage: (path: string) => string;
};

const EzManageNavContext = React.createContext<Context>({
  appName: 'OTHER',
  useMessage: () => '',
});

export default EzManageNavContext;
